// @flow
import {
  DOCUMENTS_CERTIFICATES_REQUEST,
  DOCUMENTS_CERTIFICATES_UPDATE,
  DOCUMENTS_CERTIFICATES_ERROR
} from './constants';

import type { Action, Documents } from '../types';

export const requestDocumentsCertificates = (): Action => ({
  type: DOCUMENTS_CERTIFICATES_REQUEST
});

export const updateDocumentsCertificates = (data: Documents): Action => ({
  type: DOCUMENTS_CERTIFICATES_UPDATE,
  data
});

export const errorDocumentsCertificates = (error: Error): Action => ({
  type: DOCUMENTS_CERTIFICATES_ERROR,
  error
});
